module.exports = "<div class=\"box box-border\"> <div class=box-hd> <h3 translate>Related news</h3> </div> <div class=box-bd> <slick settings=::vm.newsSliderSettings> <div ng-repeat=\"news in vm.topNewsitems\" slide> <news-tile parent-state=vm.parentState news=news></news-tile> </div> </slick> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/news/components/news-aside.html
// module id = 603
// module chunks = 0